module.exports = __webpack_public_path__ + "media/images/official/about_yamori_ooaraia-e1f6a63557220876f72d01258f1bb65d.png";